export default "__VITE_ASSET__kDJOw1TJ__"